import { Star } from 'lucide-react';
import { Reveal, SectionHeading } from '../components/Reveal';
import { TESTIMONIALS } from '../lib/site';

export const Testimonials = () => (
  <section className="bg-brand-iceSoft py-20 lg:py-28" id="testimonials" data-testid="testimonials-section">
    <div className="container-x">
      <SectionHeading
        eyebrow="Testimonials"
        title="What Our Clients Say"
        sub="Hear how businesses are growing with CapableBee AI voice assistants."
        center
      />

      <div className="mt-12 grid gap-6 lg:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.08} data-testid={`testimonial-card-${i}`}>
            <figure className="flex h-full flex-col rounded-3xl border border-brand-line bg-white p-8 shadow-card transition-all duration-300 hover:-translate-y-1 hover:shadow-lift">
              <div className="flex gap-1" aria-label="Rated 5 out of 5 stars">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-brand-honey text-brand-honey" aria-hidden="true" />
                ))}
              </div>
              <blockquote className="mt-5 flex-1">
                <p className="text-[15px] leading-relaxed text-brand-body">“{t.quote}”</p>
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-3 border-t border-slate-100 pt-6">
                <img
                  src={t.avatar}
                  alt={`Portrait of ${t.name}`}
                  width="44"
                  height="44"
                  loading="lazy"
                  className="h-11 w-11 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-extrabold text-brand-navy">{t.name}</p>
                  <p className="text-xs text-slate-400">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
